var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.17 29.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6d4d4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.14,0A10.38,10.38,0,0,0,7.91,10.5,10.7,10.7,0,0,0,10,16.84L.47,26.58a1.67,1.67,0,0,0,0,2.33,1.59,1.59,0,0,0,2.25,0h0l9.54-9.79A10.14,10.14,0,0,0,18.11,21a10.51,10.51,0,0,0,0-21m0,18.08a7.58,7.58,0,1,1,7.39-7.77v.19a7.48,7.48,0,0,1-7.39,7.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.24,5.28A1.38,1.38,0,0,0,18.41,6l0,.07A1.47,1.47,0,0,0,19.1,8c.07,0,1.76.85,1.57,2.32a1.48,1.48,0,0,0,1.22,1.65h.19a1.41,1.41,0,0,0,1.39-1.26,5.28,5.28,0,0,0-3.25-5.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.9,12.61a1.46,1.46,0,0,0-1,2.49,1.41,1.41,0,0,0,1,.43,1.39,1.39,0,0,0,1-.43,1.45,1.45,0,0,0,0-2.06,1.43,1.43,0,0,0-1-.43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.de7d44f049cc8c8f953f0851406fb631.svg";
export { ForwardRef as ReactComponent };